import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1614582969895850'

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  let n: any
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v

  const s = b.getElementsByTagName(e)[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(params?: {
  content_name?: string
  content_ids?: string[]
  content_type?: string
  value?: number
  currency?: string
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', params)
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel()
    trackPageView()
  }, [])

  return { trackAddToCart, trackPageView }
}
